import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import PasswordForm from '../components/PasswordForm';

// First login with a temporary password: the only screen that opens until the account chooses its own.
const ChoosePassword = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center p-8" data-testid="choose-password-page">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-bold text-2xl">Choisissez votre mot de passe</CardTitle>
          <CardDescription>
            Votre compte a été ouvert avec un mot de passe temporaire. Choisissez le vôtre pour continuer.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <PasswordForm
            currentLabel="Mot de passe temporaire"
            submitLabel="Enregistrer mon mot de passe"
            onChanged={() => navigate('/dashboard', { replace: true })}
          />
          <Button variant="ghost" className="w-full" onClick={async () => { await logout(); navigate('/login'); }}
            data-testid="choose-password-logout">
            Se déconnecter
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChoosePassword;
